// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.2',
  revision: 'c444954a',
  branch: 'master',
  date: 'Thu, 16 Apr 2026 09:49:22 GMT'
};